import { useFormik } from "formik";
import { basicSchema } from "./validation";
import './authentication.css'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Alert, AlertTitle, FormControl, InputAdornment, useMediaQuery } from "@mui/material";
import { useRegisterMutation } from "../../features/authApi";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTheme } from "@emotion/react";


const RegisterForm = () => {

  const [register] = useRegisterMutation()

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const handleShowPassword = () => setShowPassword(!showPassword);
  const handleShowPasswordConfirm = () => setShowPasswordConfirm(!showPasswordConfirm);

  
  const theme = useTheme()
  const [errorMessage, setErrorMessage] = useState("")  
  const [registerError, setRegisterError] = useState(false)

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));


  const onSubmit = async (values, actions) => {
    console.log("CALLED REGISTER")
    register({username: values.username, email: values.email, password: values.password})
    .then(res => {
      console.log("res on register is", res)
      if(!res.error) {
        console.log("on success")
        setSuccess(true)
        navigate(`/emailsent`)
      }  else {
        console.log("values are", values)
        console.log("error", res)
        setErrorMessage(res.error.data.message)
        setRegisterError(true)
      }
    })
    .catch(err => console.log(err))
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      email: "",
      username: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: basicSchema,
    onSubmit,
  });



  const [success, setSuccess] = useState(false)

  const navigate = useNavigate()


  const renderMobileRegister = () => (
      <>
      {success &&  
      <Alert severity="success" style={{display: 'flex', justifyContent: 'center'}}>
        <AlertTitle>Success</AlertTitle>
        You successfully registered - <strong>Please login now</strong>
        <Button onClick={() => navigate('/login')}>Login</Button>
      </Alert>}
      <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <form onSubmit={handleSubmit} autoComplete="off" style={{width: '75%'}}>
          <h3 class="center">Register</h3>

          <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              value={values.email}
              onChange={handleChange}
              id="email"
              type="email"
              margin="dense"
              onBlur={handleBlur}
              label="email"
              className={errors.email && touched.email ? "input-error" : ""}
            />
          </FormControl>
          {errors.email && touched.email && <p className="error">{errors.email}</p>}
  

          <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="username"
              type="text"
              value={values.username}
              onChange={handleChange}
              onBlur={handleBlur}
              label="username"
              margin="dense"
              className={errors.username && touched.username ? "input-error" : ""}
            />
          </FormControl>
          {errors.username && touched.username && <p className="error">{errors.username}</p>}
  
          <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="password"
              type={showPassword ? 'text' : 'password'}
              margin="dense"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              label="password"
              className={errors.password && touched.password ? "input-error" : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {
                      <VisibilityIcon color="primary" style={{backgroundColor:'#fff'}}  className="iconClass" onClick={handleShowPassword}/>
                    }
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          {errors.password && touched.password && (
            <p className="error">{errors.password}</p>
          )}
  

          <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="confirmPassword"
              type={showPasswordConfirm ? 'text' : 'password'}
              margin="dense"
              value={values.confirmPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              label="confirm password"
              className={
                errors.confirmPassword && touched.confirmPassword ? "input-error" : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {
                      <VisibilityIcon color="primary" style={{backgroundColor:'#fff'}}  className="iconClass" onClick={handleShowPasswordConfirm}/>
                    }
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          {errors.confirmPassword && touched.confirmPassword && (
            <p className="error">{errors.confirmPassword}</p>
          )}


          {registerError && <p style={{textAlign:'center', color: 'red', fontWeight:'bold'}}>{errorMessage}</p>}
          <div className="btnContainer">
            <Button variant="contained" color="primary" sx={{width: '125px'}} type="submit">
              Register
            </Button>
          </div>
          
          <p style={{textAlign: 'center', marginBottom: '20px'}}>Already have an account ? <Link color="secondary" variant="contained" sx={{width: '125px', marginTop: '10px'}} to="/login">Login</Link></p>
        </form>
      </div>
      </>
  );

  const renderTabletRegister = () => (
    <>
    {success &&  
    <Alert severity="success" style={{display: 'flex', justifyContent: 'center'}}>
      <AlertTitle>Success</AlertTitle>
      You successfully registered - <strong>Please login now</strong>
      <Button onClick={() => navigate('/login')}>Login</Button>
    </Alert>}
    <div id="formContainer">
      <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
        <h1 class="center">Register</h1>
        <TextField
          value={values.email}
          onChange={handleChange}
          id="email"
          type="email"
          margin="dense"
          onBlur={handleBlur}
          label="email"
          className={errors.email && touched.email ? "input-error" : ""}
        />
        {errors.email && touched.email && <p className="error">{errors.email}</p>}

        <TextField
          id="username"
          type="text"
          value={values.username}
          onChange={handleChange}
          onBlur={handleBlur}
          label="username"
          margin="dense"
          className={errors.username && touched.username ? "input-error" : ""}
        />
        {errors.username && touched.username && <p className="error">{errors.username}</p>}

        <TextField
          id="password"
          type={showPassword ? 'text' : 'password'}
          margin="dense"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          label="password"
          className={errors.password && touched.password ? "input-error" : ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {
                  <VisibilityIcon color="primary" style={{backgroundColor:'#fff'}}  className="iconClass" onClick={handleShowPassword}/>
                }
              </InputAdornment>
            ),
          }}
        />
        {errors.password && touched.password && (
          <p className="error">{errors.password}</p>
        )}

        <TextField
          id="confirmPassword"
          type={showPasswordConfirm ? 'text' : 'password'}
          margin="dense"
          value={values.confirmPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          label="confirm password"
          className={
            errors.confirmPassword && touched.confirmPassword ? "input-error" : ""
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {
                  <VisibilityIcon style={{backgroundColor:'#fff'}}  color="primary" className="iconClass" onClick={handleShowPasswordConfirm}/>
                }
              </InputAdornment>
            ),
          }}
        />
        {errors.confirmPassword && touched.confirmPassword && (
          <p className="error">{errors.confirmPassword}</p>
        )}

        <div className="btnContainer">
          <Button variant="contained" color="primary" id="submitBtn" type="submit">
            Submit
          </Button>
        </div>
        
        <p className="center">Already have an account ? <Button onClick={() => navigate("/login")}>Login</Button></p>
      </form>
    </div>
    </>
  );

  const renderDesktopRegister = () => (
    <>
    {success &&  
    <Alert severity="success" style={{display: 'flex', justifyContent: 'center'}}>
      <AlertTitle>Success</AlertTitle>
      You successfully registered - <strong>Please login now</strong>
      <Button onClick={() => navigate('/login')}>Login</Button>
    </Alert>}
    <div id="formContainer">
      <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
        <h1 class="center">Register</h1>
        <TextField
          value={values.email}
          onChange={handleChange}
          id="email"
          type="email"
          margin="dense"
          onBlur={handleBlur}
          label="email"
          className={errors.email && touched.email ? "input-error" : ""}
        />
        {errors.email && touched.email && <p className="error">{errors.email}</p>}

        <TextField
          id="username"
          type="text"
          value={values.username}
          onChange={handleChange}
          onBlur={handleBlur}
          label="username"
          margin="dense"
          className={errors.username && touched.username ? "input-error" : ""}
        />
        {errors.username && touched.username && <p className="error">{errors.username}</p>}

        <TextField
          id="password"
          type={showPassword ? 'text' : 'password'}
          margin="dense"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          label="password"
          className={errors.password && touched.password ? "input-error" : ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {
                  <VisibilityIcon color="primary"  style={{backgroundColor:'#fff'}} className="iconClass" onClick={handleShowPassword}/>
                }
              </InputAdornment>
            ),
          }}
        />
        {errors.password && touched.password && (
          <p className="error">{errors.password}</p>
        )}

        <TextField
          id="confirmPassword"
          type={showPasswordConfirm ? 'text' : 'password'}
          margin="dense"
          value={values.confirmPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          label="confirm password"
          className={
            errors.confirmPassword && touched.confirmPassword ? "input-error" : ""
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {
                  <VisibilityIcon color="primary" style={{backgroundColor:'#fff'}} className="iconClass" onClick={handleShowPasswordConfirm}/>
                }
              </InputAdornment>
            ),
          }}
        />
        {errors.confirmPassword && touched.confirmPassword && (
          <p className="error">{errors.confirmPassword}</p>
        )}

        <div className="btnContainer">
          <Button variant="contained" color="primary" id="submitBtn" type="submit">
            Register
          </Button>
        </div>
        
        <p className="center">Already have an account ? <Link to="/login">Login</Link></p>
      </form>
    </div>
    </>
  );


  return (
    <div>
        {
        (isXs) ?  renderMobileRegister() : 
        (isSm) ? renderMobileRegister() :
        (isMd) ? renderTabletRegister() :
        renderDesktopRegister()
      }
    </div>
  );
};
export default RegisterForm;